module.exports = __webpack_public_path__ + "media/assets/images/caret-left-8c3ec0793f563cf42f0be4e5ccd40ef4.svg";